module.exports = __webpack_public_path__ + "assets/0a34299b0c57c87591121c954f49ece4.png";